import { Field, ID, ObjectType } from 'type-graphql'
import {
  Column,
  CreateDateColumn,
  Entity,
  EntityManager,
  getRepository,
  Index,
  ManyToOne,
  PrimaryGeneratedColumn,
  RelationId,
  Repository,
  UpdateDateColumn
} from 'typeorm'

import { User } from '@things-factory/auth-base'
import { Domain } from '@things-factory/shell'

import { Setting } from '../setting/setting'

@Entity()
@Index(
  'ix_partner_setting_0',
  partnerSetting => [partnerSetting.domain, partnerSetting.partnerDomain, partnerSetting.setting],
  { unique: true }
)
@ObjectType({ description: 'Entity for PartnerSetting' })
export class PartnerSetting {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID)
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain)
  domain?: Domain

  @RelationId((partnerSetting: PartnerSetting) => partnerSetting.domain)
  domainId?: string

  @ManyToOne(type => Domain, { nullable: false })
  @Field(type => Domain, { nullable: true })
  partnerDomain: Domain

  @RelationId((partnerSetting: PartnerSetting) => partnerSetting.partnerDomain)
  @Field({ nullable: true })
  partnerDomainId?: string

  @ManyToOne(type => Setting)
  @Field({ nullable: true })
  setting: Setting

  @RelationId((partnerSetting: PartnerSetting) => partnerSetting.setting)
  @Field({ nullable: true })
  settingId?: string

  @Column({
    nullable: true
  })
  @Field({ nullable: true })
  value?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true })
  category?: string

  @CreateDateColumn()
  @Field({ nullable: true })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((partnerSetting: PartnerSetting) => partnerSetting.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((partnerSetting: PartnerSetting) => partnerSetting.updater)
  updaterId?: string

  static async get(domain: Domain, partnerDomain: Domain, name: string, tx?: EntityManager): Promise<string> {
    const partnerSettingRepo: Repository<PartnerSetting> =
      tx?.getRepository(PartnerSetting) || getRepository(PartnerSetting)
    const settingRepo: Repository<Setting> = tx?.getRepository(Setting) || getRepository(Setting)
    const setting: Setting = await settingRepo.findOneBy({ domain: { id: domain.id }, name })

    if (!setting) throw new Error(`No setting found has '${name}' as its name`)

    const domainSetting: PartnerSetting = await partnerSettingRepo.findOneBy({
      domain: { id: domain.id },
      partnerDomain: { id: partnerDomain.id },
      setting: { id: setting.id }
    })

    return domainSetting?.value || setting?.value
  }
}
